export default __webpack_public_path__ + "static/media/map_berkeley_bg_mobile2x.7c2cc032.jpg";